<template>
        <v-row class="ma-0 pa-0">
            <!--
            <v-select
                    v-model="$i18n.locale"
                    :items="langs"
                    hide-details
            >
            </v-select>
            -->

            <p class="ma-0 pa-0">{{$t('appbar.languageString')}}: <span @click="setIt" class="clickable-cursor" :style="styleIt">IT</span> | <span @click="setEn" class="clickable-cursor" :style="styleEn">EN</span></p>

        </v-row>

</template>

<script>
    export default {
        name: "LocalChanger",
        data () {
            return {
                langs: ['it', 'en'],
                styleIt: "text-decoration: underline;",
                styleEn: ""
            };
        },
        methods: {
            setIt(){
                this.$i18n.locale = "it";
                this.styleIt = "text-decoration: underline;";
                this.styleEn = ""
            },
            setEn(){
                this.$i18n.locale = "en";
                this.styleEn = "text-decoration: underline;";
                this.styleIt = "";
            },
        }
    }
</script>

<style scoped>
    .clickable-cursor{
        cursor: pointer !important;
    }
</style>